import {Typography, Box, Skeleton} from '@mui/material'
import {SkeletonContainer, TextSkeleton, FieldSkeleton, ButtonSkeleton} from '../../../../components'
import {useMobile} from '../../../../hooks'

const Label = ({children, required}) => (
    <Typography variant="inputLabel" color="text.secondary">
        {children}
        {required && (
            <>
                {' '}
                <Typography variant="inputLabel" color="error">
                    *
                </Typography>
            </>
        )}
    </Typography>
)

const Field = ({label, required}) => (
    <>
        <Label required={required}>{label}</Label>
        <FieldSkeleton label={false} />
    </>
)

// A read-only service line card, laid out like ServiceAgreementDetails' .card.
const ServiceCardSkeleton = ({mobile}) => (
    <Box sx={{p: 2, pb: 0, borderBottom: '1px solid #0d5d591f'}}>
        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
            <TextSkeleton width={24} fontSize={18} />
            <Box sx={{display: 'flex', gap: 2}}>
                <Skeleton variant="circular" width={24} height={24} sx={{m: 0.625}} />
                <Skeleton variant="circular" width={24} height={24} sx={{m: 0.625}} />
            </Box>
        </Box>
        <br />
        <Box sx={{display: 'flex', justifyContent: 'space-between', gap: 1}}>
            <Box sx={{flex: 3, display: 'flex', flexDirection: 'column', gap: 1, minWidth: 220}}>
                <Label>Service Care</Label>
                <TextSkeleton width={140} />
                <TextSkeleton width={110} />
            </Box>
            <Box sx={{flex: 1, display: 'flex', flexDirection: 'column', gap: 1}}>
                <Label>Status</Label>
                <TextSkeleton width={50} />
            </Box>
        </Box>
        <br />
        <Box sx={{display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1}}>
            <Box sx={{flex: 1, display: 'flex', flexDirection: 'column', gap: 1, minWidth: 300, mb: 2.5}}>
                <Label>Start Date - End Date</Label>
                <TextSkeleton width={170} />
            </Box>
            <Box
                sx={{flex: 1, display: 'flex', gap: 1, justifyContent: mobile ? 'space-between' : 'space-around', minWidth: 200, mb: mobile ? 2 : 0}}>
                {['Total Unit', 'Rate/Unit', 'Total Cost'].map((label, index) => (
                    <Box key={label} sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
                        <Label>{label}</Label>
                        <TextSkeleton width={[40, 36, 64][index]} />
                    </Box>
                ))}
            </Box>
        </Box>
    </Box>
)

// Mirrors the ServiceAgreementDetails form while the agreement or its lookups load. Labels stay real.
export default ({services = 0}) => {
    const {mobile} = useMobile()

    return (
        <SkeletonContainer>
            <Typography variant="h7" color="primary.dark">
                Document Details
            </Typography>
            <br />
            <br />
            <Field label="Service Agreement Number" />
            <br />
            <br />
            <Field label="Service Agreement Status" />
            <br />
            <br />
            <Field label="Diagnosis Code" required />
            <br />
            <br />
            <Box sx={{display: 'flex', gap: mobile ? 1 : 2}}>
                <Box sx={{flex: 1}}>
                    <Field label="Effective Date" required />
                </Box>
                <Box sx={{flex: 1}}>
                    <Field label="Through Date" required />
                </Box>
            </Box>
            <br />
            <br />
            <Typography variant="h7" color="primary.dark">
                Payor Details
            </Typography>
            <br />
            <br />
            <Label required>Payor Name</Label>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5, height: 42, pl: 1.25}}>
                <Skeleton variant="circular" width={20} height={20} />
                <TextSkeleton width={280} fontSize={16} />
            </Box>
            <br />
            <Field label="MA/MCO Number" required />
            <br />
            <br />
            <br />
            <Typography variant="h7" color="primary.dark">
                Services
            </Typography>
            <br />
            {Array.from({length: services}).map((_, index) => (
                <div key={index}>
                    <br />
                    <ServiceCardSkeleton mobile={mobile} />
                </div>
            ))}
            <br />
            <br />
            <ButtonSkeleton width={170} />
        </SkeletonContainer>
    )
}
